import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { PortableHeader } from 'src/components/PortableHeader/PortableHeader';
import { JobOpeningCard } from './JobOpeningCard';

export const JobOpenings = ({ showAllJobOpenings, header, jobs }) => {
  const data = useStaticQuery(graphql`
    {
      allSanityJobOpening(sort: { orderRank: ASC }) {
        nodes {
          ...getJobOpening
        }
      }
    }
  `);

  const allJobs = data.allSanityJobOpening.nodes;

  const jobsToShow = showAllJobOpenings ? allJobs : jobs;

  return (
    <Container fluid className="bg-darker bg-shapes-positions py-0">
      <Container className="py-6">
        <Row className="py-xl-6 py-3" id="jobs">
          <Col xs={12} lg={{ span: 8, offset: 2 }} className="mb-xl-6 mb-3 text-center">
            <PortableHeader className="text-white" content={header} />
          </Col>
          {jobsToShow.length &&
            jobsToShow.map((job) => (
              <Col key={job.id} xs={12} lg={{ span: 10, offset: 1 }} className="px-0 py-3">
                <JobOpeningCard {...job} />
              </Col>
            ))}
        </Row>
      </Container>
    </Container>
  );
};
